// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".errorMsg[data-v-583eef24] {\n  padding: 2px 20px 2px 20px;\n  background-color: #000000;\n  color: #26e43e;\n}\n", ""]);
// Exports
module.exports = exports;
